import { useEffect } from "react";

/**
 * SEO helper – updates document title and meta description per route.
 * Adds a JSON-LD structured-data block for the page.
 */
export default function SEO({ title, description, jsonLd }) {
    useEffect(() => {
        if (title) document.title = `${title} | أسعار الذهب اليوم`;

        if (description) {
            let tag = document.querySelector('meta[name="description"]');
            if (!tag) {
                tag = document.createElement("meta");
                tag.setAttribute("name", "description");
                document.head.appendChild(tag);
            }
            tag.setAttribute("content", description);
        }

        let ldEl = document.getElementById("page-jsonld");
        if (jsonLd) {
            if (!ldEl) {
                ldEl = document.createElement("script");
                ldEl.type = "application/ld+json";
                ldEl.id = "page-jsonld";
                document.head.appendChild(ldEl);
            }
            ldEl.textContent = JSON.stringify(jsonLd);
        } else if (ldEl) {
            ldEl.remove();
        }
    }, [title, description, jsonLd]);

    return null;
}
